<template>
    <div
        class="
            card
            col-span-12
            lg:col-span-4
            z-20
            bottom-0
            left-0
            fixed
            w-full
            lg:bg-transparent lg:w-auto lg:relative
            transition-transform
            lg:translate-y-0
        "
        :class="{ 'translate-y-[calc(100%-75px)]': !isMobileVersionOpen }"
    >
        <div
            class="
                px-4
                pt-5
                md:px-7 md:pt-6
                pb-7
                box-shadow
                bg-white
                flex flex-col
                justify-center
                items-center
                border-none
                md:border
                border-light-100
                lg:sticky
                rounded-2xl
                transition-all
            "
            :class="[
                $device.isMobileOrTablet
                    ? $store.state.globals.lastScrollDirection === 'up'
                        ? 'top-32'
                        : 'top-20'
                    : shouldCompensateForHiddenHeader
                    ? $store.state.globals.lastScrollDirection === 'up'
                        ? 'top-24'
                        : 'top-5'
                    : 'top-32',
            ]"
        >
            <div class="container p-0 lg:flex lg:items-center flex-col">
                <button
                    class="flex lg:hidden justify-between items-center w-full mb-6"
                    @click="isMobileVersionOpen = !isMobileVersionOpen"
                >
                    <span class="text-2xl font-HKGrotesk-Bold"><T t="generic.appointment_booking" /></span>
                    <i
                        class="ni ni-angle-arrow-right text-green-550 text-2xl transition-transform"
                        :class="isMobileVersionOpen ? 'rotate-90' : '-rotate-90'"
                    >
                    </i>
                </button>
                <div class="hidden lg:block mb-6 w-full text-center text-2xl font-HKGrotesk-Bold">
                    <T t="generic.appointment_booking" />
                </div>
                <div class="lg:flex lg:items-center flex-col">
                    <p class="mb-7">
                        <span>
                            <T t="appointment_booking_card.appointment_booking_description" />
                        </span>
                        <span class="mt-7"><T t="appointment_booking_card.appointment_price" /></span>
                    </p>

                    <ButtonLink
                        :to="url || $store.state.globals.medicallConsultationLink"
                        external
                        is-target-blank
                        :label="$t('generic.appointment_booking')"
                        class="p-button-md/lg xs-w-full"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BookAppointmentCard',
    props: {
        url: {
            type: String,
            required: false,
            default: null,
        },
        shouldCompensateForHiddenHeader: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isMobileVersionOpen: false,
        };
    },
    beforeMount() {
        this.$store.commit('globals/setAppointmentBookingCardExistence', true);
    },
    destroyed() {
        this.$store.commit('globals/setAppointmentBookingCardExistence', false);
    },
};
</script>

<style scoped>
.box-shadow {
    box-shadow: 0 4px 30px rgba(28, 130, 150, 0.2);
    @media (min-width: 1024px) {
        box-shadow: 0 12px 25px rgba(17, 62, 81, 0.1);
    }
}
</style>
